module.exports = __webpack_public_path__ + "static/item-7-6a9cad582f29f822bf661c221a9cebb7.jpeg";